var render = function (_h,_vm) {var _c=_vm._c;return _c('path',{attrs:{"d":"M7.95455 14L1 7.5M1 7.5L7.95455 1M1 7.5L18 7.5","stroke":"#336DD8","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})}
var staticRenderFns = []

export { render, staticRenderFns }